import { FormActivity } from "@/models/activity.model";

function buildForm(form: FormActivity): FormData {
  const formData = new FormData();
  formData.append(
    "activity",
    new Blob([JSON.stringify(form)], {
      type: "application/json",
    })
  );
  if (form?.files) {
    form.files.forEach((file: File) => {
      formData.append("files", file, file.name);
    });
  }

  return formData;
}

function updateStartDate(form: FormActivity): void {
  if (form.startDate) {
    const startDate = new Date(form.startDate);
    const timeZoneOffset = startDate.getTimezoneOffset() / 60;

    startDate.setHours(
      startDate.getHours() - timeZoneOffset,
      startDate.getMinutes(),
      0,
      0
    );
    form.startDate = startDate;
  }
}

function updateFinalDate(form: FormActivity): void {
  if (form.finalDate && form.finalHour) {
    const finalDate = new Date(form.finalDate);
    const timeZoneOffset = finalDate.getTimezoneOffset() / 60;
    const [hours, minutes] = form.finalHour.split(":").map(Number);
    finalDate.setHours(hours - timeZoneOffset, minutes, 0, 0);
    form.finalDate = finalDate;
  }
}

export { buildForm, updateFinalDate, updateStartDate };
